import app from 'flarum/common/app';

app.initializers.add('nodeloc/flarum-telegram-notification', () => {
});
